export function CountBadge({ count }: { count: number }) {
  if (count) {
    return (
      <span className="absolute -top-2 -right-2 flex size-4.5 items-center justify-center rounded-full border border-teal-400 bg-teal-50 pt-[1px] text-xs font-medium text-teal-600">
        {count}
      </span>
    );
  }
}
